import React, { useEffect } from "react";
import axios from "axios";
import { API_BASE_URL, API_URLS, LOCALSTORAGE_TOKEN_ITEM } from "constants/api";
import { LabelDetail } from "types/label";

export const useLabel = (id: string) => {
  const [label, setLabel] = React.useState<LabelDetail>();
  const [fetching, setFetching] = React.useState(true);
  const [updating, setUpdating] = React.useState(false);
  const token = localStorage.getItem(LOCALSTORAGE_TOKEN_ITEM);

  useEffect(() => {
    (async () => await getLabel(id))();
  }, []);

  const getLabel = async (id: string) => {
    try {
      setFetching(true);
      const response = await axios.get(
        `${API_BASE_URL}${API_URLS.Labels}/${id}`,
        { headers: { Accept: 'application/json', Authorization: `Bearer ${token}` } }
      );
      setLabel(response.data.data);
    } catch (e) {
      console.error(e);
    } finally {
      setFetching(false);
    }
  };

  const updateLabel = async (data: any) => {
    try {
      setUpdating(true);
      const formData = new FormData();
      Object.entries(data).forEach(([key, value]) => {
        formData.append(key, value as string);
      });
      const response = await axios.post(
        `${API_BASE_URL}${API_URLS.Labels}/${id}`,
        formData,
        { headers: { Accept: 'application/json', Authorization: `Bearer ${token}`, 'Content-Type': 'multipart/form-data', } }
      );
      setLabel(response.data.data);
    } catch (e) {
      console.error(e);
      throw e;
    } finally {
      setUpdating(false);
    }
  };

  return { label, fetching, updating, updateLabel };
};
